module.exports = __webpack_public_path__ + "static/media/rustore_icon.8e3589de.svg";